import {
  BG,
  WHITE,
  GRAY,
  DIM,
  ACCENT,
  W,
  H,
  MX,
  CONTENT_W,
  wrap,
  drawStats,
  drawRow,
  drawBadges,
  drawList,
  drawImage,
  drawTable,
} from "./drawHelpers";

export function drawSlide(doc, slide, isFirst, image, totalSlides) {
  if (!isFirst) doc.addPage([W, H], "landscape");
  doc.setFillColor(...BG);
  doc.rect(0, 0, W, H, "F");

  // number + label
  doc.setFont("courier", "normal");
  doc.setFontSize(11);
  doc.setTextColor(...ACCENT);
  doc.text(slide.n, MX, 24);
  const numW = doc.getTextWidth(slide.n);
  doc.setDrawColor(...ACCENT);
  doc.line(MX + numW + 4, 22.5, MX + numW + 16, 22.5);
  doc.setTextColor(...DIM);
  doc.setFontSize(10);
  doc.text(slide.label.toUpperCase(), MX + numW + 20, 24);

  // reserve a right-side column when this slide has a real photo
  const textW = image ? CONTENT_W - image.colW - 12 : CONTENT_W;
  const pad = image ? 4 : 20;

  // headline
  doc.setFont("helvetica", "bold");
  doc.setFontSize(27);
  doc.setTextColor(...WHITE);
  const headlineW = textW - pad;
  const hLines = wrap(doc, slide.headline, headlineW);
  let y = 46;
  doc.text(hLines, MX, y);
  y += hLines.length * 11 + 4;

  // body
  if (slide.body) {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12.5);
    doc.setTextColor(...GRAY);
    const bLines = wrap(doc, slide.body, textW - (image ? pad : 60));
    doc.text(bLines, MX, y);
    y += bLines.length * 6.4 + 10;
  } else {
    y += 6;
  }

  // extra content block
  if (slide.extra) {
    const extraY = Math.max(y, 108);
    // leave clear room above the fixed-position "learn more" link so a long
    // list's footer never collides with it
    const footerMaxY = slide.link ? H - 34 : undefined;
    if (slide.extra.type === "stats") drawStats(doc, slide.extra.items, extraY, textW);
    else if (slide.extra.type === "row") drawRow(doc, slide.extra.items, extraY, textW);
    else if (slide.extra.type === "badges") drawBadges(doc, slide.extra.items, extraY, textW);
    else if (slide.extra.type === "list") drawList(doc, slide.extra.items, extraY, slide.extra, textW, footerMaxY);
    else if (slide.extra.type === "table") drawTable(doc, slide.extra, extraY, textW);
  }

  if (image) drawImage(doc, image);

  // clickable "learn more" link to the matching page on the live site,
  // mirroring the "Go Deeper" links shown in the on-screen deck
  if (slide.link) {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9.5);
    doc.setTextColor(...ACCENT);
    doc.textWithLink(`Learn more at ${slide.link.label}`, MX, H - 24, { url: slide.link.url });
  }

  // footer
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.setTextColor(...WHITE);
  doc.textWithLink("WearSpray", MX, H - 14, { url: "https://wearspray.com" });
  doc.setFont("courier", "normal");
  doc.setFontSize(9);
  doc.setTextColor(...DIM);
  doc.text(`${slide.n} / ${String(totalSlides).padStart(2, "0")}`, W - MX - 14, H - 14);
}
